import React, { Component } from 'react';
import { sortBy } from 'lodash';
import memoizeOne from 'memoize-one';
import { compose } from 'react-apollo';
import Tab from 'react-bootstrap/Tab';
import { Link } from 'react-router-dom';
import CarouselBanner from 'containers/HomePage/SectionRows/CarouselBanner';
import TrendingNow from 'containers/HomePage/SectionRows/TrendingNow';
import GameCard from 'components/GameCard';
import GameIcon from 'components/GameIcon';
import TabView from 'components/TabView';
import { LG_BREAKPOINT_AND_UP } from 'utils/constants';
import { orderGamesByHistory } from 'utils/gameHistory';
import { getGameFavorites } from 'utils/localStorage';
import { toSlug } from 'utils/strings';
import withMediaQuery from 'utils/withMediaQuery';
import ContinuePlaying from '../ContinuePlaying';
import './GamePageNavigationBar.css';

class GamePageNavigationBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expand: false
    };

    this.newlyReleasedGameMemo = memoizeOne(newlyReleasedGame);
    this.favoriteGameMemo = memoizeOne(favoriteGame);
    this.recentlyPlayedGameMemo = memoizeOne(orderGamesByHistory);
    this.alphabeticalGameMemo = memoizeOne(alphabeticalGame);
  }

  render() {
    const {
      games = [],
      searchTerm,
      onFavorite = () => {},
      onRemoveFavorite = () => {}
    } = this.props;

    const { expand } = this.state;

    const favorites = getGameFavorites();
    const recentPlayed = this.recentlyPlayedGameMemo(games);

    const menus = [
      {
        displayName: 'Discover',
        gameSlots: false
      },
      {
        displayName: 'Newly Released',
        gameSlots: this.newlyReleasedGameMemo(games),
        max: 5
      },
      {
        displayName: 'Favorites',
        gameSlots: this.favoriteGameMemo(games, favorites),
        max: 5
      },
      {
        displayName: 'Recently Played',
        gameSlots: recentPlayed,
        max: 5
      },
      {
        displayName: 'Alphabetical',
        gameSlots: this.alphabeticalGameMemo(games),
        max: 5,
        viewAll: true
      }
    ];

    const filteredGames = menus[4].gameSlots
      .filter(({ displayName }) =>
        displayName.toLowerCase().includes(searchTerm.toLowerCase())
      )
      .slice(0, 5);

    return (
      <div className="game-page-navigation-bar-wrapper">
        {searchTerm && (
          <div className="game-page-search-slots">
            {filteredGames.length === 0 ? (
              <div className="game-page-search-no-result">No result found</div>
            ) : (
              filteredGames.map(game => (
                <Link
                  className="game-page-search-card"
                  to={`game/${game.slug}`}
                >
                  <GameIcon
                    game={game}
                    badge={game.badge}
                    alt={game.displayName}
                  />
                  <div className="sub-title">{game.displayName}</div>
                </Link>
              ))
            )}
          </div>
        )}
        <TabView
          ref={this.tabRef}
          tabTitles={menus.map(menu => ({
            title: menu.displayName,
            key: toSlug(menu.displayName)
          }))}
          className="game-page-list-tab-view"
          theme="game-page"
          navClassName="game-page-tabs"
          matchesBreakpoint={this.props.matchesBreakpoint}
          onSelectTab={() => this.setState({ expand: false })}
        >
          <Tab.Content>
            {menus.map((menu, idx) => (
              <Tab.Pane eventKey={toSlug(menu.displayName)} key={idx}>
                {menu.gameSlots ? (
                  <div className="game-slot-wrapper">
                    <button
                      className={`btn game-slot-expand${
                        menu.viewAll && !expand ? '' : ' hide'
                      }`}
                      type="button"
                      onClick={() => this.setState({ expand: true })}
                    >
                      View all
                    </button>
                    {(expand
                      ? menu.gameSlots
                      : menu.gameSlots?.slice(0, menu.max)
                    ).map((game, idx) => (
                      <GameCard
                        key={idx}
                        game={game}
                        isFavorite={favorites.includes(game.id)}
                        onFavorite={onFavorite}
                        onRemoveFavorite={onRemoveFavorite}
                      />
                    ))}
                  </div>
                ) : (
                  <>
                    <CarouselBanner />
                    <ContinuePlaying games={recentPlayed} />
                    <TrendingNow />
                  </>
                )}
              </Tab.Pane>
            ))}
          </Tab.Content>
        </TabView>
      </div>
    );
  }
}

function newlyReleasedGame(games) {
  return games.filter(({ badge }) => badge === 'new');
}

function favoriteGame(games, favorites) {
  return games.filter(({ id }) => favorites.includes(id));
}

function alphabeticalGame(games) {
  return sortBy(games, ({ displayName }) => displayName);
}

export default compose(withMediaQuery(LG_BREAKPOINT_AND_UP))(
  GamePageNavigationBar
);
